export const resources = {
  resourcesFolderInfoText: 'Файл(ів)',
  resourcesItemInfoLastUpdText: 'Оновлено',
  resourcesItemInfoUploadedText: 'Завантажено',
  resourcesSearchInputText: 'Пошук',
  resourcesUserActionSheetOptionTitle: 'Скопіювати посилання',
  resourcesActionCopiedAlertText: 'Посилання скопійовано!',
  resourcesOwnersCurtainEditOptionText: 'Редагувати назву',
  resourcesOwnersCurtainDeleteOptionText: 'Видалити',
  resourcesOwnerCurtainHideOptionText: 'Приховати (Inactive)',
  resourcesEditPopupTitle: 'Редагувати назву',
  resourcesEditPopupResetButtonTitle: 'Скинути',
  resourcesEditPopupApplyButtonTitle: 'Застосувати',
  resourcesItemEditedAlertText: 'Файл успішно оновлено!',
  resourcesHidePopupTitle: 'Приховати',
  resourcesHidePopupText: 'Приховати файл?',
  resourcesHidePopupCancelButtonTitle: 'Скасувати',
  resourcesHidePopupConfirmButtonTitle: 'Підтвердити',
  resourcesDeletePopupTitle: 'Видалення',
  resourcesDeletePopupText: 'Видалити файл?',
  resourcesDeletePopupCancelButtonTitle: 'Скасувати',
  resourcesDeletePopupConfirmButtonTitle: 'Підтвердити',
  resourcesItemDeletedAlertText: 'Файл успішно видалено!',
  resourceDetailsLinkText: 'Це зовнішня URL-адреса, вона відкриється у новому вікні. Відкрити?',
  resourceDetailsLinkOpenButtonTitle: 'Відкрити',
  resourceDetailsLinkOpenAgainButtonTitle: 'Відкрити ще раз',
  resourceDetailsLinkCopyURLButtonTitle: 'Скопіювати посилання',
  resourceDetailsLinkCopiedURLAlertText: 'Посилання скопійовано!',
  resurceDetailsLinkCurtainOptionCopyText: 'Скопіювати посилання',
  resourceDetailsFileInfoLastUpdText: 'Оновлено',
  resourceDetailsFileInfoUploadText: 'Завантажено',
  resourceDetailsFileSaveButtonTitle: 'Відкрити',
  resourceDetailsFileCopyButtonTitle: 'Скопіювати посилання',
  resourcesOwnersCurtainCopyOptionText: 'Скопіювати посилання',
  resourceDetailsFileLoadingText: 'Завантаження...',
  resourceDetailsImageCurtainCopyOptionText: 'Скопіювати посилання',
  resourceDetailsImageCurtainDownloadOptionText: 'Завантажити',
  resourceFolder: 'Папка',
  resourceAdded: 'Додано'
}
